function convertTo2DArray(inputArray, elementsPerInnerArray) {
    const outputArray = [];
    for (let i = 0; i < inputArray?.length; i += elementsPerInnerArray) {
        outputArray.push(inputArray?.slice(i, i + elementsPerInnerArray));
    }
    return outputArray;
}


export default convertTo2DArray;